import React,{useState,useEffect} from 'react';
import PostNote from './PostNote';

const PostNoteModal=({webToken,userMail,noteCat,noteRefer,modalFunc, isNotesModal})=>{
    return(
        <div id="alim-comment-modal" tabIndex="-1" className="fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full max-h-full alim-modal flex justify-center items-center bg-light-blue/50">
            <div className="relative w-full max-w-4xl">
                <div className={`flex flex-col rounded-lg shadow h-full flex flex-col bg-white ${isNotesModal=="1"?`dark:bg-deep-blue`:`dark:bg-light-blue`} pb-5`}>
                    <div className="flex items-center justify-between p-5 rounded-t absolute top-0 right-0">
                        <h3 id="db-modal-title" className="text-xl font-medium alim-text-color-style">
                           
                        </h3>
                        <button type="button" className={`rounded-lg text-sm w-8 h-8 min-h-[32px] min-w-[32px] ml-auto inline-flex justify-center items-center ${isNotesModal?`modal-close-btn-dark`:`modal-close-btn`}`} onClick={()=>{modalFunc(false)}}>
                            <div className="modal-close-img-elem w-[12px] h-[12px]"></div>
                            <span className="sr-only">Close modal</span>
                        </button>
                    </div>
                    
                    <div className="grow w-full h-full overflow-auto flex p-5">
                        <div className='w-full'>
                            <PostNote webToken={webToken} userMail={userMail} noteCat={noteCat} noteRefer={noteRefer} modalFunc={modalFunc} isNotesModal={isNotesModal}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PostNoteModal;